/*
 |--------------------------------------------------------------------------
 | Youtube
 |--------------------------------------------------------------------------
 */

function onYouTubeIframeAPIReady() {
    var ytEvent = new CustomEvent("youtubeReady", { "detail": "Youtube is ready" });
    document.dispatchEvent(ytEvent);
}

jQuery(document).ready(function($)
{

    jQuery(document).foundation();

    //load the IFrame Player API code asynchronously
    var tag = document.createElement('script');

    tag.src = "https://www.youtube.com/iframe_api";
    var firstScriptTag = document.getElementsByTagName('script')[0];
    firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);

    (function () {
        function CustomEvent ( event, params ) {
            params = params || { bubbles: true, cancelable: false, detail: undefined };
            var evt = document.createEvent( 'CustomEvent' );
            evt.initCustomEvent( event, params.bubbles, params.cancelable, params.detail );
            return evt;
        };

        CustomEvent.prototype = window.Event.prototype;
        window.CustomEvent = CustomEvent;
    })();

    if ($('#testimonial-row').length > 0) {
        getQuoteHeight();

        $(window).on('resize', function(){
            getQuoteHeight();
        });

        setInterval(rotateQuote, 9000);
    }
});

/*
 |--------------------------------------------------------------------------
 | Header
 |--------------------------------------------------------------------------
 */
var previousScroll = 0;

jQuery(window).on('scroll', function (event)
{
    /*
     |--------------------------------------------
     | Sticky Header
     |--------------------------------------------
     */

    if(jQuery(window).scrollTop() >= 250)
    {
        if (!jQuery('body').hasClass('header-sticky')) {
            var $height = jQuery('#menu-section-container').height();

            jQuery('#menu-section-spacer').height($height);
            jQuery('body').addClass('header-sticky');
        }
    }
    else
    {
        if (jQuery('body').hasClass('header-sticky')) {
            jQuery('body').removeClass('header-sticky');
        }
    }

    var $body = jQuery('body');

    var scroll = jQuery(this).scrollTop();
    if (scroll > previousScroll) {
        $body.removeClass('show-header-bar');
    } else {
        $body.addClass('show-header-bar');
    }
    previousScroll = scroll;
});

function toggleMenu() {
    jQuery('body').toggleClass('menu-open');
}

function getQuoteHeight() {
    var $maxHeight = 0;

    var $quotes = jQuery('.testimonial-column');
    $quotes.css('height', '');

    for (var $i=0; $i < $quotes.length; $i++) {
        var $quote = jQuery($quotes[$i]);

        if ($quote.outerHeight() > $maxHeight) {
            $maxHeight = $quote.outerHeight();
        }
    }

    jQuery('#testimonial-row').css('height', ''+$maxHeight+'px');
    $quotes.css('height', $maxHeight+'px');
}

function rotateQuote($element) {
    var $activeQuote = jQuery('.testimonial-column.active');
    var $nextQuote = $activeQuote.next();

    if (!$nextQuote.hasClass('testimonial-column')) {
        $nextQuote = jQuery('.testimonial-column').first();
    }

    $activeQuote.removeClass('active');
    $nextQuote.addClass('active');
}